"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.753 0c1.09 0 1.988.85 2.064 1.922l.005.147v19.862c0 1.092-.85 1.988-1.922 2.064l-.147.005H5.246a2.07 2.07 0 0 1-2.063-1.921l-.005-.148V2.069c0-1.09.849-1.988 1.92-2.064L5.247 0h13.507Zm0 .96H5.246a1.11 1.11 0 0 0-1.102.988l-.006.121v19.862c0 .57.433 1.042.987 1.102l.121.007h13.507a1.11 1.11 0 0 0 1.102-.988l.007-.121V2.069a1.11 1.11 0 0 0-.988-1.102L18.753.96Zm-6.754 9.369a5.61 5.61 0 0 1 3.992 1.652 5.611 5.611 0 0 1 1.652 3.992 5.611 5.611 0 0 1-1.652 3.99A5.61 5.61 0 0 1 12 21.616a5.606 5.606 0 0 1-3.99-1.652 5.608 5.608 0 0 1-1.653-3.991c0-1.508.587-2.926 1.653-3.992A5.606 5.606 0 0 1 12 10.33Zm0 .961a4.672 4.672 0 0 0-3.312 1.37 4.69 4.69 0 0 0 0 6.625 4.69 4.69 0 0 0 6.625 0 4.69 4.69 0 0 0 0-6.624A4.671 4.671 0 0 0 12 11.29Zm-1.182 3.5a1.676 1.676 0 0 1 2.365 0A1.671 1.671 0 0 1 12 17.643c-.428 0-.856-.163-1.183-.488a1.676 1.676 0 0 1 0-2.365Zm1.183.47a.71.71 0 0 0-.504.209.714.714 0 0 0 0 1.007.714.714 0 0 0 1.007 0 .714.714 0 0 0 0-1.007.709.709 0 0 0-.503-.208ZM9.975 3.223c1.081-1.082 2.968-1.082 4.05 0a2.868 2.868 0 0 1 0 4.05A2.857 2.857 0 0 1 12 8.11a2.856 2.856 0 0 1-2.025-.837 2.868 2.868 0 0 1 0-4.05Zm2.025.12a1.906 1.906 0 0 0-1.346 3.25A1.904 1.904 0 1 0 12 3.343Z",
    clipRule: "evenodd"
  })]
});